/* eslint-disable */     //To disable rule warnings in an entire file using ESLint comment.
import React from "react";
import docimg from "../../images/documentMan.svg"

const documentNames = [
  "Final Degree Certificate/Final Diploma Certificate",
  "Provisional Degree Certificate",
  "Official Transcript",
  "Grade Card",
  "Other Educational Document/Certificate"
];

const isTenChars = (value) => value.trim().length === 10;
const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const isEmail = (value) => {
  if (regex.test(value) === false) {
    return false;
  }
  else {
    return true;
  }
}
let agencyEmailValidity = true;
let emailValidity = true;
let agencyPhoneValidity = true;

function AgencyInfo({ formData, setFormData, checkboxStates, setCheckboxStates }) {

  const updateSelectedDocs = () => {
    //Adding all the Selected Checkboxes' name to formdata documents
    let checkboxes = document.querySelectorAll('input[type="checkbox"]');
    let docList = [];
    let newCheckboxStates = [];

    for (let checkbox of checkboxes) {
      if (checkbox.checked)
        docList.push(checkbox.value);
      newCheckboxStates.push(checkbox.checked);
    }
    setCheckboxStates(newCheckboxStates);
    setFormData(formData => ({ ...formData, Documents: docList }));
  }

  return (
    <div >
      <div className="Candidate-Info-container name-container">
        <div className="label">
          <p className="data">Full Name of the Student: </p>
          <input
            type="text"
            required
            value={formData.candidateName}
            onChange={(e) => {
              setFormData({ ...formData, candidateName: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="Ageny-Details-container">
        <div className="form-flex">
          <div className="label">
            <p className="data"> Email: </p>
            <input
              type="text" required
              value={formData.email}
              onChange={(event) => {
                setFormData({ ...formData, email: event.target.value })
                if (isEmail(event.target.value)) {
                  emailValidity = true;
                } else if (event.target.value.length === 0) {
                  emailValidity = true;
                }
                else if (!isEmail(event.target.value)) {
                  emailValidity = false;
                }
              }}
            />
            {!emailValidity && <p className="invalid">Please enter a valid Email Address</p>}
          </div>
          <div className="label">
            <p className="data">Agency Contact No :</p>
            <input
              type="text" required
              value={formData.agencyNo}
              onChange={(event) => {
                setFormData({ ...formData, agencyNo: event.target.value })
                if (isTenChars(event.target.value)) {
                  agencyPhoneValidity = true;
                } else if (event.target.value.length === 0) {
                  agencyPhoneValidity = true;
                }
                else if (!isTenChars(event.target.value)) {
                  agencyPhoneValidity = false;
                }
              }}
            />
            {!agencyPhoneValidity && <p className="invalid">Please enter Phone number of 10 digits</p>}
          </div>
        </div>
        <div className="form-flex">
          <div className="label">
            <p className="data">Name of Agency:</p>
            <input
              type="text" required
              value={formData.agencyName}
              onChange={(event) =>
                setFormData({ ...formData, agencyName: event.target.value })
              }
            /></div>
          <div className="label">
            <p className="data">Email Id of Agency : </p>
            <input           
              type="text" required
              value={formData.agencyEmail}
              onChange={(event) => {
                setFormData({ ...formData, agencyEmail: event.target.value })
                if (isEmail(event.target.value)) {
                  agencyEmailValidity = true;
                } else if (event.target.value.length === 0) {
                  agencyEmailValidity = true;
                }
                else if (!isEmail(event.target.value)) {
                  agencyEmailValidity = false;
                }
              }}
            />
            {!agencyEmailValidity && <p className="invalid">Please enter a valid Email Address</p>}
          </div>
        </div>

        <div className="label">
          <p className="data">Name and Designation of Contact person of the Agency:</p>
          <input
            type="text" required
            value={formData.Designation}
            onChange={(event) =>
              setFormData({ ...formData, Designation: event.target.value })
            }
          /></div>

      </div>
      <div className="Candidate-Info-container">
        <label id="l1"><p className="data">Select Your University:</p></label>
        <div className="form-radios">
          <input id="ur1"
            name="university-radio"
            type="radio"
            value={"MIT WPU, Kothrud Campus"}
            placeholder="Last Name..."
            onChange={(e) => {
              setFormData({ ...formData, universityName: e.target.value });
            }}
          /><label htmlFor="ur1">MIT WPU, Kothrud Campus </label>
        </div>
        <div className="form-radios">
          <input id="ur2"
            name="university-radio"
            type="radio"
            value={"MITCOE- SPPU, Kothrud Campus"}
            onChange={(e) => {
              setFormData({ ...formData, universityName: e.target.value });
            }}
          /><label htmlFor="ur2">MITCOE- SPPU, Kothrud Campus </label>
        </div>
        <div className="form-radios">

          <input id="ur3"
            name="university-radio"
            type="radio"
            value={"MIT School of Business & MITSOM (Autonomous)"}
            onChange={(e) => {
              setFormData({ ...formData, universityName: e.target.value });
            }}
          />
          <label htmlFor="ur3">MIT School of Business and MITSOM (Autonomous) </label>
        </div>
        <div className="form-flex">
          <div className="label">
            <p className="data">Name of Program:&nbsp;</p>
            <input
              type="text"
              value={formData.progamName}
              onChange={(e) => {
                setFormData({ ...formData, progamName: e.target.value });
              }}
            />
          </div>
          <div className="label">
            <p className="data">Month & Year of Passing:</p>
            <input
              type="date"  required
              value={formData.graduationDate}
              onChange={(e) => {
                setFormData({ ...formData, graduationDate: e.target.value });
              }}
            />
          </div>
        </div>
        <div className="label">
          <p className="data">Permanent Registration Number(PRN)/ Roll No:&nbsp;</p>
          <input
            type="text" required
            value={formData.prn}
            onChange={(e) => {
              setFormData({ ...formData, prn: e.target.value });
            }}
          />
        </div>

        <label id="l2" >
          <p className="data">Document(s) To be Verified:</p>
        </label>
        <div className="doc-flex">
          <div className="cb-container">
            {
              documentNames.map((name, index) =>
                <div className="form-checkboxes" key={`cb-container-${index}`}>
                  <input id={`fcb${index}`}
                    type="checkbox"
                    value={name}
                    onChange={updateSelectedDocs}
                    checked={checkboxStates[index]}
                  />
                  <label htmlFor={`fcb${index}`}>{name}</label>
                </div>
              )
            }
          </div>
          <div className="payimg-container">
            <img src={docimg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgencyInfo;
